export default __webpack_public_path__ + "static/Corentin-photo-de-profil-c8cd79553d52050cfa093586121c2b04.jpg";